/** Options for the pickup request form. */

export const wasteCategories = [
  { value: 'it-equipment', label: 'IT Equipment (laptops, desktops, monitors)' },
  { value: 'servers', label: 'Servers, Storage & Racks' },
  { value: 'networking', label: 'Networking & Telecom Equipment' },
  { value: 'printers', label: 'Printers, Scanners & Copiers' },
  { value: 'mobile', label: 'Mobile Phones & Tablets' },
  { value: 'batteries', label: 'Batteries (Li-ion, lead-acid, UPS)' },
  { value: 'appliances', label: 'Appliances & Consumer Electronics' },
  { value: 'medical', label: 'Medical & Laboratory Equipment' },
  { value: 'industrial', label: 'Industrial & Plant Electronics' },
  { value: 'cables', label: 'Cables, PCBs & Loose Components' },
  { value: 'mixed', label: 'Mixed / Unsorted E-Waste' },
];

export const quantityUnits = [
  { value: 'kg', label: 'Kilograms (kg)' },
  { value: 'MT', label: 'Metric Tonnes (MT)' },
  { value: 'units', label: 'Units / Assets' },
];

/** Demo lifecycle for a request. Order defines the "advance status" progression. */
export const requestStatuses = [
  'Submitted',
  'Verified',
  'Scheduled',
  'Collected',
  'Certified',
];

/** Tailwind classes per status, used by the Badge in the admin table. */
export const statusStyles = {
  Submitted: 'bg-ink-100 text-ink-700 border-ink-200',
  Verified: 'bg-blue-50 text-blue-700 border-blue-200',
  Scheduled: 'bg-amber-50 text-amber-700 border-amber-200',
  Collected: 'bg-violet-50 text-violet-700 border-violet-200',
  Certified: 'bg-brand-50 text-brand-700 border-brand-200',
};

/** Look up a category label from its stored value. */
export function categoryLabel(value) {
  return wasteCategories.find((c) => c.value === value)?.label || value;
}
